import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { cache, invalidateUrl } from '@appbase/util'

@Component
export default class ReadSender extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: Object }) item!: mail.EmailMessage

  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  visibleMore: boolean = false
  avatar = {
    url: '',
    loading: false,
  }

  loadingImage: string = invalidateUrl('/cm/gres/v1/img/ghost_loading.png')
  ghostImage: string = invalidateUrl('/cm/gres/v1/img/ghost.png')

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  getImage(senderMail: string) {
    this.avatar.loading = true
    const szAddress = senderMail
      cache.avatar.get(szAddress).then((url) => {
        this.avatar.url = invalidateUrl(url)
        this.avatar.loading = false
      })
  }

  viewMore() {
    if (this.visibleMore) {
      this.visibleMore = false
    } else {
      this.visibleMore = true
    }
  }
  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  created() {
    if (this.item) {
      this.getImage(this.item.address)
    }
  }

  onPhotoError() {
    console.log('set ghost image')
    this.avatar.url = this.ghostImage
  }
}
